import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.96504 14L4.24238 8.81968C3.9192 8.4652 3.9192 7.89048 4.24238 7.536C4.56554 7.18152 5.08948 7.18152 5.41264 7.536L8.96508 11.43266L14.58736 5.26584C14.91054 4.91138 15.43448 4.91138 15.75764 5.26588C16.0808 5.62036 16.08078 6.19508 15.75762 6.54956L8.96504 14Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
    />
  </svg>
);
